<template>
  <v-row justify="center" no-gutters>
    <v-col>
      <v-select
        :items="transportTypes"
        item-text="name"
        item-value="id"
        :error-messages="modelTransportTypeValidation"
        v-model="contextTransportType"
        :label="$t('delegation.form.fields.transport.transportType.name')"
        :readonly="$store.state.Delegation.readonly === true"
        persistent-hint
        :hint="validationTransportType"
        :background-color="validationTransportType !== null ? 'blue lighten-5' : null"
      />
    </v-col>
  </v-row>
</template>

<script>
import TransportTypes from "../../../../staticData/TransportTypes";
import ValidationTransportType from "./validationTransportType";

export default {
  name: "FirstRowNoneSet",
  props: {
    modelTransportType: {
      required: true
    },
    modelTransportTypeValidation: {
      required: false,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    validationTransportType: function() {
      return ValidationTransportType(this);
    },
    transportTypes: TransportTypes,
    contextTransportType: {
      set: function(value) {
        this.$emit("update:modelTransportType", value);
      },
      get: function() {
        return this.modelTransportType;
      }
    }
  }
};
</script>

<style scoped></style>
